import React, { Component } from 'react';
//mui
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography
} from '@mui/material';
//i18n
import i18n from '../../i18n';
//context
import { AppDataContext } from '../../context/Context';

class ChangePasswordDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPass: null,
            oldPass: null
        };
    }
    //props: open, onClose, userId, askCurrent — askCurrent when users change their
    // own password, which the backend accepts only with the current one —
    // and subject, whose password it is when it is someone else's.
    static contextType = AppDataContext;

    handlePasswordValueChanged(event) {
        this.setState({ newPass: event.target.value });
    }

    async handleChangePassDialogSave(event) {
        let result = await this.context
            .getState()
            .server.users.changePass(
                this.props.userId,
                this.state.newPass,
                this.props.askCurrent ? this.state.oldPass : undefined
            );
        if (result.error === 'OK') {
            this.context.update({
                alertError: {
                    message: i18n.t('errors.passwordChanged'),
                    severity: 'success'
                }
            });
            this.props.onClose();
        } else {
            this.context.update({
                alertError: {
                    message: i18n.t('errors.passwordNotChanged')
                }
            });
        }
    }
    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={(event) => this.props.onClose(event)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {i18n.t('text.changePassword')}
                    {this.props.subject && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            noWrap
                            title={this.props.subject}
                        >
                            {this.props.subject}
                        </Typography>
                    )}
                </DialogTitle>
                <DialogContent>
                    <Stack
                        component="form"
                        spacing={2.5}
                        noValidate
                        autoComplete="off"
                    >
                        {this.props.askCurrent && (
                            <TextField
                                autoFocus
                                id="currentPassField"
                                label={i18n.t('text.currentPassword')}
                                type="password"
                                autoComplete="current-password"
                                defaultValue=""
                                fullWidth
                                onChange={(event) =>
                                    this.setState({ oldPass: event.target.value })
                                }
                            />
                        )}
                        <TextField
                            autoFocus={!this.props.askCurrent}
                            id="changePassField"
                            label={i18n.t('text.newPassword')}
                            type="password"
                            autoComplete="new-password"
                            defaultValue=""
                            fullWidth
                            onChange={(event) =>
                                this.handlePasswordValueChanged(event)
                            }
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="inherit"
                        onClick={(event) => this.props.onClose(event)}
                    >
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={(event) =>
                            this.handleChangePassDialogSave(event)
                        }
                    >
                        {i18n.t('buttons.change')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ChangePasswordDialog;
